export const getCheckedCustomers = (state, name) => state?.[name]?.checked;

export const submittingBulkAction = state => state?.customers?.submittingBulkAction;

export const getSingleCustomerFetching = state => state?.customers?.singleFetching;

export const getCustomerData = (state, iri) => state.customers?.[iri];
